module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Middle Atlantic PGA-3eb4f98dc04bb65f7af426d96b44b79a.png";